export enum EnvironmentName {
  PROD = 'prod',
  STAGE = 'stage',
  DEV = 'dev',
  LOCAL = 'local',
}

export interface Environment {
  apiUrl: string;
  name: EnvironmentName;
  stripeKey: string;
  branchKey: string;
  sentryDsn?: string;
}
